"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcMeterReadings = class UcMeterReadings extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    meter;
    onMeter(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("meter");
    }
    items;
    async $$load_items() {
        return this.$fn.fetch('list_meter_reading', { parameters: { 'meter-id': this.meter.id } });
    }
    ux;
    b_7315092382398562_paging;
    b_7315092382398562_columns;
    dataMembers = ['items', 'ux', 'b_7315092382398562_paging', 'b_7315092382398562_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                items: null,
                ux: {
                    initialLoadSpinner: true,
                },
                b_7315092382398562_paging: false,
                b_7315092382398562_columns: [{
                        name: "locked",
                        type: "lock",
                    },
                    {
                        name: "inactive",
                        header: this.$fn.gettext("Inactive"),
                        width: "30px",
                        textAlign: "center",
                        formatter: {
                            name: "checkbox",
                        },
                        editor: {
                            name: "checkbox",
                        },
                    },
                    {
                        name: "value",
                        type: "number",
                        header: this.$fn.gettext("Value"),
                        width: "110px",
                        validator: ["required",
                            "numeric",
                        ],
                    },
                    {
                        name: "unit",
                        header: this.$fn.gettext("Unit"),
                        width: "110px",
                        required: true,
                    },
                    {
                        name: "reading_type",
                        header: this.$fn.gettext("Reading Type"),
                        width: "120px",
                        required: true,
                        default: "reading",
                    },
                    {
                        name: "reading_date",
                        type: "date",
                        header: this.$fn.gettext("Reading Date"),
                        required: true,
                        width: "120px",
                    },
                    {
                        name: "reading_time",
                        type: "time",
                        header: this.$fn.gettext("Reading Time"),
                        required: true,
                        width: "120px",
                    },
                    {
                        name: "notes",
                        type: "textarea",
                        header: this.$fn.gettext("Notes"),
                        width: "200px",
                    },
                ],
            },
        };
    }
    async act_7315092382398562_script_9816_getActionArgs_value($event) {
        $event.data.waitFor(this.$fn.crud('meter_reading').upsert($event.data.row));
    }
    async act_7315092382398562_script_9816_getActionArgs($event) {
        return {
            value: () => this.act_7315092382398562_script_9816_getActionArgs_value($event),
        };
    }
    async evh_7315092382398562_save(event, scope) {
        return await this.actions.evh_7315092382398562_save.executeFromDOM(this, event, scope);
    }
    async act_7315092382398562_script_9818_getActionArgs_value($event) {
        $event.data.waitFor(this.$fn.crud('meter_reading').delete($event.data.row));
    }
    async act_7315092382398562_script_9818_getActionArgs($event) {
        return {
            value: () => this.act_7315092382398562_script_9818_getActionArgs_value($event),
        };
    }
    async evh_7315092382398562_delete(event, scope) {
        return await this.actions.evh_7315092382398562_delete.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_script_9816 = new core_1.actions.ScriptAction({
            actionArgs: this.act_7315092382398562_script_9816_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_save_9815 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_script_9816,
            event: "save",
            displayName: "script",
        });
        const evh_7315092382398562_save = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_save_9815],
        });
        const act_7315092382398562_script_9818 = new core_1.actions.ScriptAction({
            actionArgs: this.act_7315092382398562_script_9818_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_delete_9817 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_script_9818,
            event: "delete",
            displayName: "script",
        });
        const evh_7315092382398562_delete = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_delete_9817],
        });
        return {
            act_7315092382398562_script_9816,
            evh_7315092382398562_save_9815,
            evh_7315092382398562_save,
            act_7315092382398562_script_9818,
            evh_7315092382398562_delete_9817,
            evh_7315092382398562_delete,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcMeterReadings.prototype, "meter", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('meter'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcMeterReadings.prototype, "onMeter", null);
UcMeterReadings = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcMeterReadings);
exports.default = UcMeterReadings;
vue_property_decorator_1.Vue.component("UcMeterReadings", UcMeterReadings);
